class LanguageUtils {
 
  static languageMap = {
    'pl': 'pl-PL',    // 波兰语
    'es': 'es-ES',    // 西班牙语
    'it': 'it-IT',    // 意大利语
    'fr': 'fr-FR',    // 法语
    'de': 'de-DE',    // 德语
    'en': 'en-US',    // 英语（美国）
    'zh': 'zh-CN',    // 中文（简体）
  };

  static getStandardLanguage(shopifyLocale) {
    const locale = shopifyLocale || (window.Shopify && Shopify.locale) || 'en';
    const languageCode = locale.split('-')[0]; // 提取基础代码（如 'fr-CA' → 'fr'）
    return this.languageMap[languageCode] || 'en-US'; // 回退到 'en-US'
  }
}